import type { AnalyticsListener } from '../types/listener.js';

export interface RegisteredListener {
  id?: string;
  listener: AnalyticsListener;
}

/**
 * Holds enabled listener instances. Populated at init.
 */
export class ListenerRegistry {
  private readonly listeners: RegisteredListener[] = [];

  add(id: string | undefined, listener: AnalyticsListener): void {
    this.listeners.push({ id, listener });
  }

  getAll(): RegisteredListener[] {
    return [...this.listeners];
  }

  clear(): void {
    this.listeners.length = 0;
  }
}
